import React, { useState } from "react";
import { ListGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import BankAccount from "../../components/BankAccount";
import LoaderButton from "../../components/LoaderButton";
import photo1 from "../../images/brokerage.svg";
import etrade from "../../images/etrade.png";
import FormImage from "../../layouts/formimage";
import { Constants } from "../../libs/Constants";
import { update } from "../../libs/dbFunctions";
import "./LinkBrokerageAccount.scss";
const LinkBrokerageAccount = (props) => {
  const [showAddBankAccount, setShowAddBankAccount] = useState(false);
  const [selectedBroker, setSelectedBroker] = useState(null);
  const handleSuccess = async (response) => {
    let details = response["_links"]["funding-source"]["href"].split("/");
    if (details[details.length - 1] === props.userObj?.bank_information) {
      toast.error(
        "You have already added this as bank account. Please select another account"
      );
      return;
    }
    toast.success("Account added successfully");

    let saveFields = {
      ...props.userObj,
      broker_information: details[details.length - 1],
    };
    //update the userObj with salary and flags
    try {
      await update(Constants.dbTypes.USER, saveFields);
      window.location.href = "/onboardingcomplete";
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        toast.error(e.response.data.error);
      } else {
        toast.error(e);
      }
    }
  };

  return (
    <FormImage
      title="Congratulations - the Final Step"
      subtitle="This allows us to recoup our funds after you benefit from the profits. Everything is automatic & secure."
      image={photo1}
      bgClass="background-purple"
    >
      <h2 className="text-center pb-3">Link Brokerage Account</h2>
      <div className="w-100">
        <div className="font-secondary text-start font-14 mb-1">
          Who's your broker?
        </div>
        <ListGroup
          horizontal
          className="broker-list"
          defaultActiveKey={selectedBroker}
        >
          <ListGroup.Item
            action
            onClick={(e) => {
              e.preventDefault();
              setSelectedBroker("#etrade");
            }}
            href="#etrade"
          >
            <div className="brokerDiv d-flex justify-content-center align-items-center">
              <img alt="E trade" src={etrade}></img>
            </div>
          </ListGroup.Item>
        </ListGroup>
      </div>
      <LoaderButton
        block
        type="submit"
        variant="primary"
        size="lg"
        text="Next"
        className="my-4"
        disabled={!selectedBroker}
        onClick={() => setShowAddBankAccount(true)}
      >
        Connect Brokerage Account
      </LoaderButton>
      {showAddBankAccount && (
        <BankAccount
          title="Add Brokerage Account"
          show={showAddBankAccount}
          onHide={(result, response) => {
            setShowAddBankAccount(false);
            if (response) {
              if (!result) {
                toast.error(response);
              } else {
                handleSuccess(response);
              }
            }
          }}
          userObj={props.userObj}
          props={props}
        ></BankAccount>
      )}
    </FormImage>
  );
};

export default LinkBrokerageAccount;
